var ColorFormatter = Object.create(null);

ColorFormatter.getReadableTextColor = getReadableTextColor;
ColorFormatter.getDarkenColor = getDarkenColor;

/**
 * Permet de récupérer la couleur sombre du code couleur en entrée
 * @param {string} colorHex - Couleur au format hexadécimal (ex: #FFFFFF)
 * @param {number} [amount=30] - Montant à soustraire pour assombrir la couleur (0-255)
 * @returns {string} - La couleur sombre au format hexadécimal
 */
function getDarkenColor(colorHex, amount = 30) {
  var color = colorHex.replace('#', '');

  if (color.length === 3) {
    color = color.split('').map(c => c + c).join('');
  }

  const r = Math.max(0, parseInt(color.substring(0, 2), 16) - amount);
  const g = Math.max(0, parseInt(color.substring(2, 4), 16) - amount);
  const b = Math.max(0, parseInt(color.substring(4, 6), 16) - amount);

  return `#${ [ r, g, b ].map(c => c.toString(16).padStart(2, '0')).join('') }`;
}

/**
 * Fonction pour obtenir une couleur de texte lisible sur un fond donné
 * @param {string} backgroundHex - Couleur au format hexadécimal (ex: #FFFFFF)
 * @returns {string} - Couleur de texte au format rgba
 */
function getReadableTextColor(backgroundHex) {
  let r = parseInt(backgroundHex.slice(1, 3), 16),
      g = parseInt(backgroundHex.slice(3, 5), 16),
      b = parseInt(backgroundHex.slice(5, 7), 16),
      luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.87)';
}

module.exports = ColorFormatter;
